"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassTabButton = void 0;
var classTabButton_1 = require("./classTabButton");
Object.defineProperty(exports, "ClassTabButton", { enumerable: true, get: function () { return __importDefault(classTabButton_1).default; } });
